import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {FireInTheHole2} from "../../FireInTheHole2";
import {FITH2SoundManager} from "../../sound/FITH2SoundManager";
import {FITH2Symbol} from "../../symbols/FITH2Symbol";
import {FITH2Split} from "../../symbols/FITH2Split";

export class SplitPresentation implements SimplePresentation {
    name:string = "SplitPresentation";

    shouldRun():boolean {
        return FireInTheHole2.model.splitOnReel.length > 0;
    }

    private createSplitTl(split:number[], fast:boolean):gsap.core.Timeline {
        const splitTl = gsap.timeline(), speed:number = 0.05;
        for(let j:number = 0; j < 6; j++) {
            const sym:FITH2Symbol = FireInTheHole2.reelArea.getSymbol([j, split[1]]);
            const isBehindDirt:boolean = sym.isBehindDirt;
            if(j === split[0]) {
                splitTl.add((<FITH2Split>sym).splitSymbolHighlight(), 0);
            } else {
                splitTl.add(sym.split(-1), Math.abs(j - split[0]) * speed + 0.33);
            }

            //if(isBehindDirt && sym.symName === "S") {
                //splitTl.add(ScatterCounter.addScatter(<FITH2Scatter>sym), Math.abs(j - split[0]) * speed);
            //}
        }
        return splitTl;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline(),
            transformSymbols:FITH2Symbol[] = [],
            fast:boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN);// || FireInTheHole2.model.hasNoAvalancheWin),

        tl.add(() => controller.setSkipCallback(() => {
            tl.progress(1);
        }));
        let newSplits:number[][] = [],
            rowSplitDelay:number[] = [0, 0, 0, 0, 0, 0],
            splitsOnRow:number[] = [0, 0, 0, 0, 0, 0];

        FireInTheHole2.model.splitOnReel.forEach((split:number[]) => {
            for(let j:number = 0; j < 6; j++) {
                const sym:FITH2Symbol = FireInTheHole2.reelArea.getSymbol([j, split[1]]);
                if(j === split[0]) {
                    transformSymbols.push(sym);
                }

                if(sym.isBehindDirt && sym.symName === "X") {
                    newSplits.push([j, split[1]]);
                }
            }

            tl.add(this.createSplitTl(split, fast), rowSplitDelay[split[1]]);
            rowSplitDelay[split[1]] += 0.2;
            splitsOnRow[split[1]]++;
        });

        for(let s:number = 0;s<Math.max(...splitsOnRow);s++){
            tl.add(() => {
                FITH2SoundManager.playSound(`xsplitExpand${FireInTheHole2.model.hasNoAvalancheWin ? "No" : ""}Win`)
            }, s*0.2);
        }
        const delay:number = tl.duration();
        if(newSplits.length > 0) {
            rowSplitDelay = [0, 0, 0, 0, 0, 0];
            splitsOnRow = [0, 0, 0, 0, 0, 0]
            newSplits.forEach((newSplit:number[]) => {
                for(let j:number = 0; j < 6; j++) {
                    const symbol:FITH2Symbol = FireInTheHole2.reelArea.getSymbol([j, newSplit[1]]);
                    if(j === newSplit[0]) {
                        transformSymbols.push(symbol);
                    }
                }
                tl.add(this.createSplitTl(newSplit, fast), delay + rowSplitDelay[newSplit[1]]);
                rowSplitDelay[newSplit[1]] += 0.1;
                splitsOnRow[newSplit[1]]++;
            });
            for(let s:number = 0;s<Math.max(...splitsOnRow);s++){
                tl.add(() => {
                    FITH2SoundManager.playSound(`xsplitExpand${FireInTheHole2.model.hasNoAvalancheWin ? "No" : ""}Win`)
                }, delay +s*0.2);
            }
        }

        const transformTl = gsap.timeline();
        transformSymbols.forEach((symbol:FITH2Symbol) => {
            transformTl.add(FireInTheHole2.reelArea.switchSymbol(symbol, FireInTheHole2.model.xRevealTo), 0);
        });
        tl.add([
            ()=>{FITH2SoundManager.playSound("xsplitTransform")},
            transformTl
        ]);
        tl.add(() => {
            controller.finish();
        });
    }
}